import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Route, Switch, useRouteMatch } from 'react-router'
import TileButtonComponent from '../../components/common/tileButton/TileButtonComponent'
import { SubPackageModal } from '../../models/package/subPackageModal'
import { getUserSubPackages } from '../../store/user/selectors'
import { fileRegistrationRoute } from '../../utils/constants'
import Compensation from '../compensationRecommendation/compensation/Compensation'
import FileRegistration from '../applicationRegistration/fileRegistration/FileRegistration'
import Loan from '../compensationRecommendation/loan/Loan'
import compensation_recommendation from '../../assets/images/recommendation.svg'

const CompensationRecommendation = () => {
  const { path } = useRouteMatch()
  const subPackageList = useSelector(
    getUserSubPackages('compensation-recommendation')
  )

  const renderSubPackages = () => {
    return subPackageList.map((subPackage: SubPackageModal, index: number) => {
      return (
        <Col key={`sub-package-${index}`} xs={4}>
          <TileButtonComponent
            name={subPackage.description}
            routeURL={subPackage.name}
          />
        </Col>
      )
    })
  }
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Row className="title-layout">
          <Col className="d-flex justify-content-start">
            <img src={compensation_recommendation} alt="" />
            <span className="m-2">Compensation Recommendation</span>
          </Col>
        </Row>
        <Row className="page-tiles-layout">{renderSubPackages()}</Row>
      </Route>
      <Route
        path={`${path}/${fileRegistrationRoute}`}
        component={FileRegistration}
      />
      <Route path={`${path}/compensation`} component={Compensation} />
      <Route path={`${path}/loan`} component={Loan} />
    </Switch>
  )
}

export default CompensationRecommendation
